export default __webpack_public_path__ + "static/media/basicInfoGreetings.81dfca17.jpg";